<!-- <ion-bottom-sheet [(state)]="sheetState" [dockedHeight]="dockerBottomSheetHeight" [canBounce]="false"
  [transition]="0.25" title="Login or Sign up" *ngIf="showMobileLogin">
  <app-auth-modal [isMobile]="isMobile" [isSignup]="isSignup"></app-auth-modal>
</ion-bottom-sheet> -->
<nav class="navbar navbar-transparent navbar-fixed-top" role="navigation">
  <div class="container">

    <div class="navbar-header ">
      <img class="navbar-logo " src="../../../assets/images/logos/wing-icon.png" />
      <button type="button" class="navbar-toggle" (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed" aria-controls="navbarsExampleDefault" aria-label="Toggle navigation">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </div>

    <div class="collapse navbar-collapse main-header" [ngbCollapse]="isCollapsed">
      <ul class="nav navbar-nav d-none d-md-block d-lg-block d-xl-block d-xxl-block logo-list">
        <li>
          <img class="logo" src="../../../assets/images/logos/logo-300.png" />

        </li>
      </ul>

      <ul class="nav navbar-nav navbar-right">
        <li><a (click)="openAuth(true)" class="">Become an instructor</a></li>
        <li><a (click)="openAuth(false)" class="">Help</a></li>
        <li><a (click)="openAuth(true)" class="">Sign up</a></li>
        <li><a (click)="openAuth(false)" class="">Log in</a></li>
      </ul>
    </div>
  </div>
</nav>

<div class="row hero align-items-center">
  <div class="col-xl-12 h-100 ">


    <div class="row align-items-start justify-content-center ">
      <div class="col-xl-5 m-t-100 d-none d-md-block d-lg-block d-xl-block d-xxl-block">
        <h1>Accelerate your performance</h1>
        <a class="me-lg-3 mb-4 mb-lg-0" href="#!"><img class="app-badge" src="assets/images/svg/google-play-badge.svg"
            alt="..." /></a>
        <a href="#!"><img class="app-badge" src="assets/images/svg/app-store-badge.svg" alt="..." /></a>
      </div>
      <div class="col-xl-6 m-t-100 ">
        <app-instructor-search></app-instructor-search>
      </div>
    </div>

    <div class="row">
      <div class="col-xl-5"></div>
      <div *ngIf="isMobileWeb" class="col-xl-6 	">
        <h1>Accelerate your performance</h1>
        <a class="me-lg-3 mb-4 mb-lg-0" href="#!"><img class="app-badge" src="assets/images/svg/google-play-badge.svg"
            alt="..." /></a>
        <a href="#!"><img class="app-badge" src="assets/images/svg/app-store-badge.svg" alt="..." /></a>
      </div>
    </div>

  </div>
  <br />
  <br />
  <div class="d-flex justify-content-between">
    <h5>ThriveNetwork {{year}}</h5>
    <a href="https://thrivenetwork.app/privacy" target="_blank">Privacy</a>
  </div>

</div>
